
import Layout from '../../../components/layout/index'
import GraficoBarra from '../../../components/graficoBarra';
import GraficoPizza from '../../../components/graficoPizza';
import { ContainerCardsExplicativos, ContainerFiltrosEActions, ContainerGraficos, ContainerLayout, Grafico } from '../../Batismo/Dash/style';
import { ServicesDashboard as useServices } from '../services/getCrmDados'
import ModalFiltro from '../../../components/modalFiltros';
import SedeStackComponent from '../../Pg/DashboardPg/stacks/sedes';
import MembrosStackComponent from '../../Pg/DashboardPg/stacks/membros';
import CelulaStackComponent from '../../Pg/DashboardPg/stacks/celulas';
import TipoPgStackComponent from '../../Pg/DashboardPg/stacks/tipospgs';
import EstadosStackComponent from './stacks/estados';


export default function DashboardCRM() {

  const { getPessoasPorMinisterioSede, tipoDePg, estadosCadastrados, todosRegistros, pessoasPorEstadoCivil, pessoasPorGenero, pessoasPorIdade, pessoasPorSede, totalDeCelulas } = useServices({
  });

  return (
    <>
      <>
        <ContainerLayout>
          <ContainerFiltrosEActions>
            <ModalFiltro>
              <></>
            </ModalFiltro>
          </ContainerFiltrosEActions>
          <ContainerCardsExplicativos>
            <SedeStackComponent
              objectWithValues={pessoasPorSede}
            />
            <MembrosStackComponent
              objectWithValues={todosRegistros}
            />
            <CelulaStackComponent
              objectWithValues={totalDeCelulas}
            />
            <TipoPgStackComponent
              objectWithValues={tipoDePg}
            />
            <EstadosStackComponent
              objectWithValues={estadosCadastrados?.filter(el => el?.estado)}
            />
          </ContainerCardsExplicativos>
          <ContainerGraficos>
            <Grafico>
              <GraficoBarra
                titulo={"Participantes por Sede"}
                keyX='quantidade'
                value='sedes'
                keyForExctratTitles='nomesede'
                dados={pessoasPorSede ?? []}
                color={"#108dff"} />
            </Grafico>

            <Grafico>
              <GraficoBarra
                titulo={"Participantes por Idade"}
                keyX='quantidade'
                value='Medias'
                keyForExctratTitles='media'
                dados={pessoasPorIdade ?? []}
                color={"#108dff"} />
            </Grafico>
            <Grafico>
              <GraficoPizza
                title={'Participantes por Gênero'}
                cores={['#E8C29C', '#99E7FF', '#759', '#f00895', '#789456', '#963']}
                descricaoDados='quantidade'
                descricao='genero'
                dados={pessoasPorGenero ?? []}
              />
            </Grafico>
            <Grafico>
              <GraficoPizza
                title={'Estado Cívil'}
                cores={['#E8C29C', '#99E7FF', '#759', '#f00895', '#789456', '#963']}
                descricaoDados='quantidade'
                descricao='estadocivil'
                dados={pessoasPorEstadoCivil ?? []}
              />
            </Grafico>


          </ContainerGraficos>
        </ContainerLayout>
      </>
    </>
  )

}
